export enum LightspeedPayloadField {
  EMAIL = 'email',
}
